<template>
  <div class="d-flex flex-wrap px-1 py-2 gap-2 rounded keyword-input__container">
    <v-chip
      v-for="(kw, index) in keywords"
      :key="index+kw"
      dark
      class="fs-10 white--text text-uppercase"
      color="black">
      {{ kw }}
      <v-icon
        small
        right
        @click="removeKeyword(index)">
        mdi-close
      </v-icon>
    </v-chip>
    <input
      v-model="input"
      type="text"
      class="ml-2 pa-1 black--text"
      placeholder="Add keywords"
      @keydown.enter.prevent="addKeyword"
      @blur="addKeyword">
  </div>
</template>

<script>
export default {
  name: 'AppKeywordInput',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: '',
      keywords: [...(this.value || [])],
    };
  },
  watch: {
    value(newVal) {
      this.tags = [...newVal];
    },
    keywords(newKeywords) {
      this.$emit('input', newKeywords);
    },
  },
  methods: {
    addKeyword() {
      if (this.input.trim() === '') return;

      const newKeywords = this.input
        .split(',')
        .map(kw => kw.trim())
        .filter(kw => kw && !this.keywords.includes(kw));
      this.keywords.push(...newKeywords);
      this.input = '';
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.keyword-input__container {
  border: 1px solid var(--v-darkGrey-base);

  input {
    outline: none;
    &::placeholder {
      color: var(--v-darkGrey-base);
    }
  }
}
</style>